import { useId } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, AvatarWithLabel, Typography, Link } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useAutotagFeatureAvailability } from 'app/domains/metadata';
import { SwitchFieldUncontrolled } from 'shared/domains/forms';
import { useGetLinks } from 'shared/domains/urls';
import { MistakeNotice, UpgradeNotice } from './styled';
export function AutoTag(props) {
    const { enabled, disabled, onChange } = props;
    const { contact } = useGetLinks();
    const featureAvailability = useAutotagFeatureAvailability();
    const id = useId();
    const label = enabled
        ? t({ message: 'Enabled', comment: 'Metadata: Auto tag enabled on document save' })
        : t({ message: 'Disabled', comment: 'Metadata: Auto tag disabled on document save' });
    const handleChange = () => onChange(!enabled);
    return (<Box flexDirection="column" gap="lg">
      <SwitchFieldUncontrolled title={t({
            message: 'AI auto tagging',
            comment: 'Upload documents dialog settings - AI auto tagging label',
        })} subtitle={t({
            message: 'Automatically extract vital metadata',
            comment: 'Upload documents dialog settings - AI auto tagging description',
        })} icon={<Falcon icon="tag"/>} label={label} checked={enabled} disabled={Boolean(!featureAvailability.data || disabled)} onCheckedChange={handleChange}/>

      <Box flexDirection="column" gap="sm">
        {featureAvailability.data && (<MistakeNotice>
            <Typography $fontSize="tiny" $appearance="100">
              <Trans comment="Save file: Auto tagging notice" id={id} aria-hidden="true">
                AI can make mistakes. Verify important information.
              </Trans>
            </Typography>
          </MistakeNotice>)}

        {!featureAvailability.data && (<UpgradeNotice>
            <AvatarWithLabel size="md" appearance="assistant" truncate={false} title={t({
                message: 'Upgrade',
                comment: 'Metadata: Auto tag save composer upgrade CTA',
            })} subtitle={t({
                message: 'This is an enterprise feature.',
                comment: 'Metadata: Auto tag save composer feature availability subtitle',
            })}>
              <Falcon icon="circle-up"/>
            </AvatarWithLabel>

            <Box ml="auto">
              <Link href={contact} size="small" target="_blank" rel="noopener noreferrer">
                <Trans comment="Save document auto tag feature: Button triggering chat">Get feature</Trans>
              </Link>
            </Box>
          </UpgradeNotice>)}
      </Box>
    </Box>);
}
